import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { SectionTitleButtons } from 'library/components/controls/layout/SectionTitleButtons';
import { ServiceAreaTabs } from 'library/components/controls/layout/tabs/ServiceAreaTabs';
import { PageContentTab } from 'library/components/controls/pageTemplates/PageContent';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { reactPlugin } from 'main/azureInsights/config';
import { ErrorComponentFallback } from 'main/errors/ErrorComponentFallback';
import { MaintenancePlannerButton } from 'modules/Shared/Components/Buttons/MaintenancePlannerButton';
import { servicesAreaTabsConfiguration } from 'modules/UnitOverview/servicesAreaTabsConfiguration';

const ServiceAreaPage = (): React.JSX.Element => {
	const { trackApplicationInteraction } = useAdobeTracking();

	return (
		<>
			<SectionTitleButtons>
				<MaintenancePlannerButton source="UnitOverview" />
			</SectionTitleButtons>
			<ServiceAreaTabs
				tabs={servicesAreaTabsConfiguration}
				onTabClick={(tabPath) =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'UNITOVERVIEW Service Area Tab Navigation',
						selectedOptions: [{ attribute: 'tab', value: tabPath }],
					})
				}
			/>
			<PageContentTab ErrorFallbackComponent={ErrorComponentFallback} />
		</>
	);
};

export default withAITracking(
	reactPlugin,
	ServiceAreaPage,
	'UnitOverviewServiceAreaPage',
	'application-insight-container'
);
